import { Project } from "@/api/project";
import { z } from "zod";

const REQUIRED_FIELD_ERROR = "Required Field";

export const ProjectSchema = z
  .object({
    id: z.string(),
    name: z.string().trim().nonempty(REQUIRED_FIELD_ERROR),
    number: z.string().trim().nonempty(REQUIRED_FIELD_ERROR),
    description: z.string().trim().nonempty(REQUIRED_FIELD_ERROR),
  })
  .transform((data) => data as Project);
